import React from 'react'
import { Link } from 'react-router-dom'
import { Container, Button } from 'semantic-ui-react'

export default function FreeEstimate() {
  return (
    <div className="free-estimate">
      <Container>
        <div>
          <h1 className="title" style={{ fontSize: '2.1em' }}>
            Free Estimate
          </h1>
          <div style={{ fontSize: '1.2em', lineHeight: '1.5em' }}>
            <div>Ready to take care of your trees?</div>
            <div>Contact us to get your no-obligation estimate.</div>
            {/* tailored to your trees */}
            <div>{`It's that simple.`}</div>
          </div>
          <Button
            color="green"
            style={{ margin: '20px 0 0 0' }}
            size="large"
            as={Link}
            to="/contact">
            Get Started Today
          </Button>
        </div>
      </Container>
    </div>
  )
}
